import script from "./AddCategory.vue?vue&type=script&ts=lang&setup=true&lang=js"
export * from "./AddCategory.vue?vue&type=script&ts=lang&setup=true&lang=js"

import "./AddCategory.vue?vue&type=style&index=0&id=77404644&lang=scss&scoped=true"

import exportComponent from "/Users/ttheitao/Desktop/devApps/onetab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77404644"]])

export default __exports__